import { ammendTeamName } from "projectSpecific/sports/cnr/reducers/SportsMatchReducer";

export function ammendMedia_alignment(result, existingTeams, _url, database_fns) {

  if (!result) return []

  const doc = new DOMParser().parseFromString(result, 'text/html')

  const alignments = {};
  const teamRecords = {}
  const teams = {}
  const nonTeams = []
  let sportsYearStandings;

  doc.querySelectorAll('.sport').forEach((sport) => {
    const _standings = sport.querySelectorAll('.team-top')
    if (_standings) {
      const header = sport.querySelectorAll('h2')
      try {
        if (header && header[0]) {
          sportsYearStandings = header[0].textContent.split(' ')[0]
          sportsYearStandings = sportsYearStandings.split('-')[1]
        }
      } catch (error) {
        console.log('error', error)
      }
    }
    sport.querySelectorAll('.standings').forEach((standingsDiv) => {
      standingsDiv.querySelectorAll('table').forEach((table) => {
        let _district = getClosestDiv(table, 'district-name');
        switch (_district) {
          case 'WPIAL':
            let _level = getClosestDiv(table, 'classification-name');
            let _section = getClosestDiv(table, 'conference-name');
            if (_level && _section) {

              _level = _level.replace('Class ', '')
              _section = _section.replace('(' + _level + ')', '')
              _section = _.camelCase(_section)

              table.querySelectorAll('tbody').forEach((tbody) => {
                tbody.querySelectorAll('tr').forEach((tr) => {

                  let team;
                  let _itemKey;

                  tr.querySelectorAll('td').forEach((td, index) => {
                    switch (index) {
                      case 0:
                        team = td.textContent.trim()
                        team = ammendTeamName(team)

                        const _team = _.find(existingTeams, { name: team })
                        _itemKey = _team ? _team._itemKey : database_fns.get_docKey()

                        teamRecords[_itemKey] = {
                          name: team,
                          [sportsYearStandings]: {
                            record: '',
                            overallRecord: '',
                            section: _section,
                            level: convertHelpers.compactText(_level)
                          }
                        }

                        if (!alignments[_level]) { alignments[_level] = { sections: {} } }
                        if (!alignments[_level].sections[_section]) { alignments[_level].sections[_section] = { teams: {} } }
                        if (_team) {
                          alignments[_level].sections[_section].teams[_team.name] = {
                            name: _team.name,
                            _itemKey: _itemKey,
                            exists: true
                          }
                        } else {
                          alignments[_level].sections[_section].teams[team] = {
                            name: team,
                            _itemKey: _itemKey
                          }
                          nonTeams.push(team)
                        }
                        break;
                      case 1:
                        const r = td.textContent.trim()
                        teamRecords[_itemKey][sportsYearStandings].record = r
                        break;
                      case 3:
                        const ro = td.textContent.trim()
                        teamRecords[_itemKey][sportsYearStandings].overallRecord = ro
                        break;
                      default:
                    }

                  })
                })
              })
            }
            break;
          default:
          // nothing
        }
      })
    })
  })

  _.forEach(alignments, (alignment, levelKey) => {
    const { sections } = alignment
    _.forEach(sections, (section, sectionKey) => {
      const { teams: teams_section } = section
      let position = 0
      _.forEach(teams_section, (team, teamKey) => {
        const { name, _itemKey } = team
        teams[_itemKey] = {
          name,
          sections: sectionKey,
          levels: levelKey,
          position
        }
        position++
      })
    })
  })

  const sectionCounts = getSectionCountsFromTeams(teams)

  return { sportsYearStandings, alignments, sectionCounts, teams, teamRecords, nonTeams, _url }
}